import React, { useState, useEffect } from 'react';
import { Alert, Badge } from 'react-bootstrap';
import { FiClock } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useTrialStatus } from '../../hooks/useTrialStatus';

const SimpleTrialBanner = () => {
    const navigate = useNavigate();
    const { hasTrial, isExpired, daysRemaining, trialEndDate, loading } = useTrialStatus();
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        if (loading || !hasTrial || isExpired || !trialEndDate) {
            return;
        }

        const calculateTimeLeft = () => {
            const now = new Date();
            const endDate = new Date(trialEndDate);
            const diff = endDate - now;

            if (diff <= 0) {
                return 'Trial Expired';
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

            return `${days}d ${hours}h ${minutes}m`;
        };

        // Update immediately
        setTimeLeft(calculateTimeLeft());

        // Update every minute
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 60000);

        return () => clearInterval(timer);
    }, [hasTrial, isExpired, trialEndDate, loading]);

    const getAlertVariant = () => {
        if (daysRemaining <= 0) return 'danger';
        if (daysRemaining <= 1) return 'danger';
        if (daysRemaining <= 3) return 'warning';
        return 'info';
    };

    // Don't show if loading, no trial, or expired
    if (loading || !hasTrial || isExpired || daysRemaining <= 0) {
        return null;
    }

    return (
        <Alert
            variant={getAlertVariant()}
            className="mb-3 d-flex align-items-center justify-content-between"
            style={{
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                animation: 'slideDown 0.3s ease-out'
            }}
        >
            <div className="d-flex align-items-center">
                <FiClock size={20} className="me-2" />
                <div>
                    <strong>🎉 Free 7-Day Trial:</strong> {timeLeft} remaining
                    <Badge bg="light" text="dark" className="ms-2" style={{ fontWeight: 600, padding: '0.35em 0.65em' }}>
                        {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'} left
                    </Badge>
                </div>
            </div>
            <button
                className="btn btn-sm btn-primary"
                onClick={() => navigate('/pricing')}
                style={{ whiteSpace: 'nowrap' }}
            >
                Upgrade Now
            </button>
        </Alert>
    );
};

export default SimpleTrialBanner;
